import { useMutation } from '@apollo/client';
import { useTranslation } from "next-i18next";
import { SUBSCRIBE_NEWSLETTER } from '@/graphql/mutations';
import { SubscribeMutation, SubscribeMutationVariables } from '@/graphql/types';


export const useSubscribe = () => {
    const { i18n } = useTranslation(); // Translations
    const [subscribeMutation, { loading, error }] = useMutation<SubscribeMutation, SubscribeMutationVariables>(SUBSCRIBE_NEWSLETTER, {
        context: { headers: { 'X-Language': i18n.language } },
    });

    const subscribe = async ({
        variables,
        onCompleted,
        onUpdate,
        onError,
    }: {
        variables?: SubscribeMutationVariables;
        onCompleted?: (data?: SubscribeMutation) => Promise<void>;
        onUpdate?: (status?: number | null, errors?: ({ field: string; messages: string[] } | null)[] | null) => void;
        onError?: (error: unknown) => Promise<void>;
    }) => {
        try {
            const { data } = await subscribeMutation({
                variables,
                update: (cache, result) => {
                    const { status, errors } = result?.data?.subscribe || {};
                    if (onUpdate) onUpdate(status, errors);
                },
                onCompleted: (dat) => {
                    if (onCompleted) void onCompleted(dat);
                },
                onError: (err) => {
                    if (onError) void onError(err);
                },
            });

            return data?.subscribe;
        } catch (err) {
            if (onError) void onError(err);
            throw err;
        }
    };

    return { subscribe, loading, error };
};
